import type { SceneDesignId } from 'js/src/data/templates/templates-types';

/**
 * This class is used to keep track of if there is a call to updateSceneGroupDurationToEqualVoiceDrivenAssetDuration
 * scheduled for a specific scene group. If there is not, and there is a duration mismatch between the
 * scene group and the voicedriven asset, we will log an error.
 */
class VoiceDrivenSceneGroupDurationFixerSchedule {
    schedule: Record<SceneDesignId, number> = {};
    constructor() {
        this.schedule = {};
    }

    increment(sceneGroupId: string) {
        if (this.schedule[sceneGroupId]) {
            this.schedule[sceneGroupId]++;
        } else {
            this.schedule[sceneGroupId] = 1;
        }
        return this.schedule[sceneGroupId];
    }
    decrement(sceneGroupId: string) {
        if (this.schedule[sceneGroupId]) {
            this.schedule[sceneGroupId]--;
            if (this.schedule[sceneGroupId] <= 0) {
                delete this.schedule[sceneGroupId];
            }
        }
    }

    isFixScheduledFor(sceneGroupId: string) {
        return this.schedule[sceneGroupId] > 0;
    }
}

const voicedrivenSceneGroupDurationFixerSchedule = new VoiceDrivenSceneGroupDurationFixerSchedule();
export default voicedrivenSceneGroupDurationFixerSchedule;
